import { Box, Container, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import BasePage from './BasePage';

const ComingSoon = () => {
  return (
    <BasePage
      title="Coming Soon | CribCritic"
      description="This feature is coming soon"
      keywords="coming soon"
    >
      <Container maxWidth="md">
        <Box
          sx={{
            minHeight: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 6,
              textAlign: 'center',
              borderRadius: 3,
              maxWidth: 500,
            }}
          >
            <ConstructionIcon
              sx={{
                fontSize: 100,
                color: 'primary.main',
                mb: 3,
              }}
            />
            <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
              Coming Soon
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
              We're working on something exciting. Check back soon!
            </Typography>
          </Paper>
        </Box>
      </Container>
    </BasePage>
  );
};

export default ComingSoon;
